import React from "react";
import { motion } from "framer-motion";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import SelectableCard from "./SelectableCard";


const containerVariants = {
    hidden: { opacity: 0 },
    show: { opacity: 1, transition: { staggerChildren: 0.1 } },
};
const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    show: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } },
};


const RestStepDesktop = ({ paginatedList, canPrev, canNext, currentPage, totalPages, setCurrentPage, onItemClick }) => (
    <div className="rest-matrix-wrapper">
        <button className="matrix-nav left" onClick={() => currentPage > 0 && setCurrentPage((p) => p - 1)} disabled={!canPrev} aria-label="السابق">
            <FiChevronLeft size={40} />
        </button>


        <button className="matrix-nav right" onClick={() => currentPage < totalPages - 1 && setCurrentPage((p) => p + 1)} disabled={!canNext} aria-label="التالي">
            <FiChevronRight size={40} />
        </button>


        <motion.div className="rest-matrix two-rows" variants={containerVariants} initial="hidden" animate="show">
            {paginatedList.map((item) => (
                <motion.div key={item.id} variants={cardVariants}>
                    <SelectableCard item={item} onClick={onItemClick} />
                </motion.div>
            ))}
        </motion.div>
    </div>
);


export default RestStepDesktop;